import { PlannedOccurrence, Task, Timestamp, WeekDays } from '@griply/types';
import { addMonths } from 'date-fns';

import { getTaskPlanning } from './get-task-planning';

export type GetNextOccurrenceOptions = {
  today: Timestamp;
  weekStartsOn: WeekDays;
  from?: Timestamp;
};

// Probed in order, so only long-interval schedules pay for the full horizon.
const horizonMonths = [2, 24];

// Contiguous, so widening the horizon never re-expands a range already searched.
const probeWindows = (measureFrom: Timestamp) =>
  horizonMonths.map((months, index) => ({
    startDate: index
      ? addMonths(measureFrom, horizonMonths[index - 1])
      : measureFrom,
    endDate: addMonths(measureFrom, months),
  }));

// A plain date window, not one schedule's timeframes: a replacement schedule must stay reachable.
export const getNextOccurrence = (
  task: Task,
  { today, weekStartsOn, from }: GetNextOccurrenceOptions,
): PlannedOccurrence | undefined => {
  if (!task.schedules?.length) {
    return undefined;
  }

  for (const { startDate, endDate } of probeWindows(from ?? today)) {
    const [next] = getTaskPlanning(task, {
      startDate,
      endDate,
      today,
      weekStartsOn,
      uncompletedOnly: true,
    });

    if (next) {
      return next;
    }
  }

  return undefined;
};
